import clsx from 'clsx'
import type { CSSProperties, PropsWithChildren } from 'react'
import classes from './paper.module.css'

type PaperProps = PropsWithChildren<{
  elevation?: number
  className?: string
  style?: CSSProperties
}>

/**
 * Paper component that provides a material design elevation effect.
 *
 * @param {number} [elevation] - The elevation level (0-7).
 * @param {string} [className] - Additional custom class names.
 * @param {CSSProperties} [style] - Custom styles for the component.
 * @param {ReactNode} [children] - Content to be rendered inside the paper.
 */
export function Paper(props: PaperProps) {
  const { elevation = 0, children, className = '', style } = props

  const normalizedElevation = Math.max(0, Math.min(7, elevation))
  const elevationClass = classes[`elevation${normalizedElevation}`]
  const cls = clsx(classes.root, elevationClass, className)

  return (
    <div className={cls} style={style}>
      {children}
    </div>
  )
}
